import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Metadata } from '../model/metadata';

interface MetadataState {
    data: Metadata | null;
    isLoading: boolean;
    error: string | null;
}

const initialState: MetadataState = {
    data: null,
    isLoading: false,
    error: null
};

const metadataSlice = createSlice({
    name: 'metadata',
    initialState,
    reducers: {
        setMetadata: (state, action: PayloadAction<Metadata>) => {
            state.data = action.payload;
            state.isLoading = false;
            state.error = null;
        },
        setMetadataLoading: (state, action: PayloadAction<boolean>) => {
            state.isLoading = action.payload;
        },
        setMetadataError: (state, action: PayloadAction<string>) => {
            state.error = action.payload;
            state.isLoading = false;
        },
        clearMetadata: (state) => {
            state.data = null;
            state.error = null;
        }
    }
});

export const { setMetadata, setMetadataLoading, setMetadataError, clearMetadata } = metadataSlice.actions;
export default metadataSlice.reducer; 